export const gameName = 'crazyworm';
export const socketGamePath = 'turbogame';
